import { createContext, useContext, useEffect } from 'react';
import {
  ESTADO_INICIAL,
  type DestinoDeLlamada,
  type EstadoDeLlamada,
  type ResultadoDeLlamadaSip,
} from './estado';

export interface Softphone {
  enabled: boolean;
  configLista: boolean;
  state: EstadoDeLlamada;
  durationSeconds: number;
  lastResult: ResultadoDeLlamadaSip | null;
  call: (destino: DestinoDeLlamada) => Promise<boolean>;
  hangUp: () => void;
  toggleMute: () => void;
  sendDigit: (tecla: string) => void;
  dismiss: () => void;
  panelReclamado: boolean;
  reclamarPanel: () => () => void;
}

const SIN_SOFTPHONE: Softphone = {
  enabled: false,
  configLista: true,
  state: ESTADO_INICIAL,
  durationSeconds: 0,
  lastResult: null,
  call: async () => false,
  hangUp: () => undefined,
  toggleMute: () => undefined,
  sendDigit: () => undefined,
  dismiss: () => undefined,
  panelReclamado: false,
  reclamarPanel: () => () => undefined,
};

export const SoftphoneContext = createContext<Softphone>(SIN_SOFTPHONE);

export const useSoftphone = (): Softphone => useContext(SoftphoneContext);

export function useReclamarPanel(activo: boolean): void {
  const { reclamarPanel } = useSoftphone();
  useEffect(() => (activo ? reclamarPanel() : undefined), [activo, reclamarPanel]);
}
